export const STOCK_CARD_WIDGET_NAMESPACE = 'widget.stock-card'
